<template>
  <el-table-column
    prop="customer_address.city"
    sortable="custom"
    label="Város"
    show-overflow-tooltip
    min-width="150"
  >
    <template slot-scope="scope">
      <span>{{ scope.row.customer_city }}</span>
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'customer_address.city',
  };
</script>
